import React from 'react'
import Layout from '../Layout'

export default function aboutus(props) {
    return (
        <Layout props={props}>
            <div className="px-5 py-4 stctPgWrpr">
                <h2 className="text-center mb-3">About Us</h2>
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.privacy,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
